export default "__VITE_ASSET__CNoze4cx__"